import React from 'react';
import Header from './Header';
import Footer from './Footer';

/**
 * MainLayout - Ana sayfa layout'u
 */
function MainLayout({ children }) {
  return (
    <div className="main-layout">
      <Header />
      <main className="main-content">
        {children}
      </main>
      <Footer />
    </div>
  );
}

export default MainLayout;
